const supportedLocales = ['en', 'ar', 'he', 'es'];

export const localizedPath = (path: string) => {
    const currentLocale = window.location.pathname.split('/')[1];
    const locale = supportedLocales.includes(currentLocale) ? currentLocale : 'en';

    return `/${locale}${path.startsWith('/') ? path : `/${path}`}`;
};
